import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import {Sabko} from '../App';
import '../style/Formcom.css';

function Projects() {
  const navigate=useNavigate();
    const {state,dispatch}=useContext(Sabko);
    const[Value,setValue]=useState({})
    
    const changeVal=(e)=>{
      const name=e.target.name;
      const value=e.target.value;
      setValue((prev)=>({...prev,[name]:value}))
  
    }
  
    const submitPersoal=(e)=>{
      e.preventDefault();
      if(Object.keys(Value).length===0 && !state.User?.Projects){
        navigate('/') 
      }else{
        dispatch({type:"PROJECTS_DETAIL",payload:{...Value} });
        navigate('/') 
      }
    }
  return (
    <div className='main'>

        <form className='Homediv'>
        
            <div className='inputdiv'>
            <label htmlFor='project1' className='inputLabel'>Project 1</label>
            <input type='text'  id='project1' name='project1'
            value={(Value.project1)||((Value.project1==="")?(""):(state.User?.Projects?.project1) || (""))} 
             className='inputContent' onChange={changeVal}/>
            </div>
            <div className='inputdiv'>
            <label htmlFor='project2' className='inputLabel'>Project 2</label>
            <input type='text'  id='project2' name='project2'
            value={(Value.project2)||((Value.project2==="")?(""):(state.User?.Projects?.project2) || (""))} 
             className='inputContent' onChange={changeVal}/>
            </div>
            <div className='inputdiv'>
            <label htmlFor='project3' className='inputLabel'>Project 3</label>
            <input type='text'  id='project3' name='project3'
            value={(Value.project3)||((Value.project3==="")?(""):(state.User?.Projects?.project3) || (""))} 
             className='inputContent' onChange={changeVal}/>
            </div>
            <div className='inputdiv'>
            <label htmlFor='project4' className='inputLabel'>Project 4</label>
            <input type='text'  id='project4' name='project4'
            value={(Value.project4)||((Value.project4==="")?(""):(state.User?.Projects?.project4) || (""))} 
             className='inputContent' onChange={changeVal}/>
            </div>


            <div className='saveDiv'>
            <Button variant="contained" type='submit' className='saveButt' onClick={submitPersoal}>
            Save</Button>
            </div>

        </form>
        </div> 
  )
}

export default Projects